import * as React from 'react';

import { PromoModalActions } from '../../components/PromoModalActions';
import { SendMessageButtonContainer } from '../AsideContacts/SendMessageButton';
import { PurchaseTermsCallButton } from '../PurchaseTermsContainer/PurchaseTermsCallButton';

interface IPromoModalActionsProps {
  modalType: 'prices_modal' | 'purchase_term_modal';
}

export const PromoModalActionsContainer = ({ modalType }: IPromoModalActionsProps) => {
  // TODO modaltype by checkpoint
  return (
    <PromoModalActions>
      <SendMessageButtonContainer
        title="Чат с застройщиком"
        theme="fill_secondary"
        ariaLabel="Чат с застройщиком"
        noMarginTop
        placeType={modalType}
      />
      <PurchaseTermsCallButton modalType={modalType} />
    </PromoModalActions>
  );
};
